import { DiscountsForm } from 'components/discounts/DiscountsForm/DiscountsForm'
import { useParams } from 'react-router-dom'

export const DiscountsCreate: React.FC = () => {
  const { sellerId } = useParams<{ sellerId?: string }>()
  return <DiscountsForm mode='create' sellerId={sellerId} />
}
